import React from "react";
import { useLanguage } from "../../../../contexts";
import { ASPECT_COLOR, mixHex } from "./visualColors";

// "Pilares": una columna por aspecto activo, con la reducción media en el
// encabezado y la lista de objetivos debajo. Puerto de renderPilares() del
// mockup de referencia (sustemia_objetivos_matriz_estrategia.html).
export function PillarsVisual({ groups, baseYear, horizonEnd, siteName }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  if (!groups.length) return null;

  return (
    <div style={{ maxWidth: 760, margin: "6px auto 26px" }}>
      <div style={{ display: "grid", gridTemplateColumns: `repeat(${groups.length},1fr)`, gap: 14, alignItems: "stretch" }}>
        {groups.map(({ aspect, objetivos, avgReduction }) => {
          const color = ASPECT_COLOR[aspect] || "#5E89B4";
          const metas = objetivos.reduce((s, o) => s + (o.metas || []).length, 0);
          return (
            <div key={aspect} style={{ border: `1px solid ${mixHex(color, 0.5)}`, borderRadius: "12px 12px 0 0", overflow: "hidden", display: "flex", flexDirection: "column" }}>
              <div style={{ background: color, color: "#fff", padding: "13px 10px", textAlign: "center" }}>
                <div style={{ fontFamily: "'Sora',sans-serif", fontWeight: 700, fontSize: 14, letterSpacing: 2.5 }}>{t(aspect).toUpperCase()}</div>
                <div style={{ fontSize: 11, opacity: 0.9, marginTop: 2 }}>
                  {t("pd_pillars_avg_reduction")} {avgReduction.toFixed(1).replace(".", ",")}%
                </div>
              </div>
              <div style={{ background: mixHex(color, 0.88), padding: "12px 12px", flex: 1 }}>
                {objetivos.map((o) => (
                  <div key={o._id} style={{ fontSize: 11.5, color: "#1A3562", padding: "6px 0", borderBottom: `1px dashed ${mixHex(color, 0.6)}` }}>
                    <strong>−{o.reductionTons}%</strong> {o.source} <span style={{ color: "#6B7A8E" }}>· {t("pd_pillars_by_year")} {o.year}</span>
                  </div>
                ))}
                <div style={{ fontSize: 10, color: "#6B7A8E", marginTop: 8 }}>
                  {metas} {metas === 1 ? t("pd_pillars_goal_singular") : t("pd_pillars_goal_plural")}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ background: "#1A3562", color: "#fff", borderRadius: "0 0 10px 10px", padding: 10, textAlign: "center", fontFamily: "'Sora',sans-serif", fontWeight: 700, letterSpacing: 2, fontSize: 13 }}>
        {t("pd_wheel_plan_label")} {baseYear}–{horizonEnd} · {(siteName || "").toUpperCase()}
      </div>
    </div>
  );
}
